import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { TooltipDirectionTitle, TooltipOn } from "../../../../Constants/Constants";
import { TooltipDirectionSubTitle, TooltipPosition } from "../../../../Data/UiKits/Tooltip";

const TooltipDirection = () => {
  const [openIndex, setOpenIndex] = useState(-1);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? -1 : index);

  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={TooltipDirectionTitle} span={TooltipDirectionSubTitle} />
        <CardBody>
          <div className="common-flex">
            {TooltipPosition &&
              TooltipPosition.map((item, index) => (
                <Fragment key={index}>
                  <Btn color={item.class} id={`direction_${index}`} onClick={() => toggleTooltip(index)}>
                    {TooltipOn} {item.position}
                  </Btn>
                  <ToolTip isOpen={openIndex === index} placement={item.position} target={`direction_${index}`} toggle={() => toggleTooltip(index)}>
                    {TooltipOn} {item.position}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TooltipDirection;
